import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '@/lib/config';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Skeleton } from '@/components/ui/skeleton';

export function NewsPreview({ limit = 4 }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let c = false;
    (async () => {
      try {
        const res = await axios.get(`${API}/news`);
        if (!c) setItems((res.data.items || []).slice(0, limit));
      } catch (e) {
        void e;
      } finally {
        if (!c) setLoading(false);
      }
    })();
    return () => { c = true; };
  }, [limit]);

  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {[...Array(limit)].map((_, i) => <Skeleton key={i} className="h-32 w-full" />)}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
      {items.map((it) => (
        <Card key={it.id} className="border-[#D7E1EF] bg-white" data-testid="news-item-card">
          <CardContent className="p-5">
            <div className="flex items-center gap-2">
              <Badge variant="outline" className="border-[#D7E1EF] text-[#062B5C]">{it.category}</Badge>
              <span className="text-xs text-[#5B6B82]">{it.date}</span>
            </div>
            <div className="mt-3 font-semibold text-[#0B1220]">{it.title}</div>
            <div className="mt-2 text-sm text-[#5B6B82] leading-relaxed">{it.summary}</div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
